import axios from "axios";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { logOut } from "../../common/utils";
import { toast } from "react-toastify";
import { param } from "jquery";

export default class TicketsService {


  getTicketList(from, to, state, onSuccess, onError) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("ticket_user"));
    if(objUser != null) {
      const configHeaders = {
        headers: {
          "Authorization-Manage-Project": "Bearer " + objUser.token,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        },
        params: {
          from,
          to,
          state
        }
      };
      axios
        .get(host + "/manageproject/api/v1/ticket", configHeaders)
        .then(
          function (result) {
            if(result.status === 401){
              logOut();
            }
            onSuccess(result.data.map((element) => {return {
              "id": element.id,
              "utente": element.utente,
              "dataCreazione": new Date(element.dataCreazione),
              "categoria": element.categoria,
              "oggetto": element.oggetto,
              "descrizione": element.descrizione,
              "stato": element.stato
            }}));
          },
          function (error) {
            if((error.response != null && error.response != undefined) && error.response.status === 401){
              logOut();
            }
            console.log("errore" + error);
            onError();
          }
        );
    } else {
      onError();
    }
  }

  getDetailTicket(idTicket, onSuccess, onError) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("ticket_user"));
    const configHeaders = {
      headers: {
        "Authorization-Manage-Project": "Bearer " + objUser.token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/manageproject/api/v1/ticket/" + idTicket, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          let element = result.data;
          //console.log("Allegati " + element.allegati)
          onSuccess({
            "id": element.id,
            "utente": element.utente,
            "allegati": element.allegati.map((attachment) => {
              return {
                "id": attachment.id,
                "name": attachment.nomeFile
              }
            }),
            "dataCreazione": new Date(element.dataCreazione),
            "oggetto": element.oggetto,
            "descrizione": element.descrizione,
            "stati": element.stati
          });
        },
        function (error) {
          if((error.response != null && error.response != undefined) && error.response.status === 401){
            logOut();
          }
          console.log("errore" + error);
          onError();
        }
      );
  }

  saveTicket(ticket, onSuccess, onError) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("ticket_user"));
    ticket.utente = objUser.username;
    const configHeaders = {
      headers: {
        "Authorization-Manage-Project": "Bearer " + objUser.token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .post(host + "/manageproject/api/v1/ticket", ticket, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data.id);
        },
        function (error) {
          if((error.response != null && error.response != undefined) && error.response.status === 401){
            logOut();
          }
          console.log("errore" + error);
          onError();
        }
      );
  }

  saveAttachment(idTicket, attachment, onSuccess, onError) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("ticket_user"));
    let formData = new FormData();
    formData.append("file", attachment);
    const configHeaders = {
      headers: {
        "Authorization-Manage-Project": "Bearer " + objUser.token,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .post(host + "/manageproject/api/v1/allegati/" + idTicket, formData, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess();
        },
        function (error) {
          if((error.response != null && error.response != undefined) && error.response.status === 401){
            logOut();
          }
          console.log("errore" + error);
          onError();
        }
      );
  }

  getAttachment(idAttachment, onSuccess, onError) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("ticket_user"));
    const configHeaders = {
      headers: {
        "Authorization-Manage-Project": "Bearer " + objUser.token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(host + "/manageproject/api/v1/allegati/" + idAttachment, configHeaders)
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result.data);
        },
        function (error) {
          if((error.response != null && error.response != undefined) && error.response.status === 401){
            logOut();
          }
          console.log("errore" + error);
          onError();
        }
      );
  }

  retriveTicketToken (tk,onSuccess,onError){
  let host = process.env.REACT_APP_API_URL;
  try{
  const headers = {
    Authorization: "Bearer " + tk,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  };
  axios
    .post(host + "/api/v1/manage/tickets/public/auth/login",null,headers).then(
      (result)=>{
        sessionStorage.setItem("ticket_user",JSON.stringify(result.data));
        onSuccess();
      },
      (error)=>{
        onError();
      }
    )
  }catch(e){
    console.log("Errore nel retriveTicketToken: ", e);
  }
}

}
